export const GET_VENDOR_DETAILS = 'GET_VENDOR_DETAILS';
export const UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE';
export const UPDATE_REGISTER_FORM = 'UPDATE_REGISTER_FORM';
export const CLEAR_REGISTER_FORM = 'CLEAR_REGISTER_FORM';
export const UPDATE_TERMS_SERVICE = 'UPDATE_TERMS_SERVICE';
export const SEARCH_USERS = 'SEARCH_USERS';
export const CLEAR_USER_LIST = 'CLEAR_USER_LIST';
export const USERS_COUNT_CHECK = 'USERS_COUNT_CHECK';
